module.exports = __webpack_public_path__ + "static/media/Team5.3182de95.jpg";